import React from 'react';

import { useModal } from '@common/react/components/Modal/ModalContextProvider';
import Button from '@common/react/components/Forms/Button';
import { phoneFormat } from '@common/react/utils/utils';

import { Location } from '@app/objects/Location';
import { getLocationName } from '@app/utils/Utils';

interface Props {
	location?: Location;
	phone: string | undefined;
	className?: string;
}

const ShowPhone: React.FC<Props> = ({ location, phone, className = 'btn btn-sm btn-primary' }) => {
	const { renderModal } = useModal();
	const [visible, setVisible] = React.useState(false);
	if (!phone) return null;
	const title = location ? getLocationName(location, true, true) : 'Make a Call';

	return <>
		{renderModal(visible, () => setVisible(false), {
			title: <div className="ellipsis" title={title as string} style={{ maxWidth: 'calc(100% - 60px)' }}>
				{title}
			</div>,
			style: {
				maxWidth: '90vw',
			},
			footer: null,
			children: <div className="text-center">
				<a href={`tel:${phone}`} className="button-component btn btn-sm btn-primary">
					<i className="fa fa-phone mr10" />
					{phoneFormat(phone || '+12453339090').replace(/\+1 ?/, '')}
				</a>
			</div>,
		})}
		<Button
			type="button"
			className={className}
			onClick={() => setVisible(true)}
		>
			Make a Call
		</Button>
	</>;
};

export default ShowPhone;
